import { FormikContextType } from 'formik';

type FormProps<T> = Pick<
  FormikContextType<T>,
  | 'errors'
  | 'values'
  | 'handleChange'
  | 'handleBlur'
  | 'touched'
  | 'submitCount'
>;

type ValidationStatus = 'valid' | 'invalid' | undefined;

const useFieldProps =
  <T>(formProps: FormProps<T>) =>
  <Field extends keyof T>(name: Field) => {
    const { errors, values, handleChange, handleBlur, touched, submitCount } =
      formProps;

    let validationStatus: ValidationStatus;

    if (errors[name] && touched[name]) {
      validationStatus = 'invalid';
    } else if (!errors[name] && values[name]) {
      validationStatus = 'valid';
    } else {
      validationStatus = undefined;
    }

    return {
      name,
      id: name,
      value: values[name],
      onChange: handleChange,
      onBlur: handleBlur,
      validationText:
        touched[name] || submitCount > 0 ? errors[name] : undefined,
      validationStatus,
    };
  };

export { useFieldProps };
